<div [attr.class]="allowsSelectionCancel ? 'input-group' : null" matAutocompleteOrigin #origin="matAutocompleteOrigin">
	<input [name]="id" [id]="id"
	 	type="text"
		#input="matAutocompleteTrigger"
		[matAutocompleteConnectedTo]="origin"
		[matAutocomplete]="dropdownlist"
		[matAutocompletePosition]="'below'"
		[ngClass]="inputClass"
		[formControl]="filterInput"
		[attr.disabled]="disabled ? true : null"
		(focus)="onInputFocus()"
		(blur)="onInputBlur()"
		(click)="onInputClick()"
		(keyup)="onInputKeyUp($event)"
		/>
	<select
		*ngIf="panelOpen && categoryList && (categoryList.length || wildcardCategoryLabel)"
		[ngClass]="['categorySelector',selectClass]"
		[ngModel]="selectedCategory"
		(ngModelChange)="onCategoryChange($event)"
		(focus)="onSelectFocus()"
		>
		<option *ngIf="wildcardCategoryLabel" [ngValue]="null">{{ wildcardCategoryLabel }}</option>
		<option *ngFor="let category of categoryList" [ngValue]="category">{{ getCategoryLabel(category) }}</option>
	</select>
	<div *ngIf="allowsSelectionCancel" class="input-group-addon">
		<a class="" href="#" onclick="return false;"  [title]="actionTitle" (click)="onSelectionCancel()">
			<span [ngClass]="disabled ? ['fa', actionIconClass, 'fa-lg', 'disabled'] : ['fa', actionIconClass, 'fa-lg']"></span>
		</a>
	</div>
</div>
<mat-autocomplete 
	#dropdownlist="matAutocomplete"
	[displayWith]="getLabel"
	(optionSelected)="onOptionSelected($event)"
	(opened)="panelOpen = true"
	(closed)="panelOpen = false"
	panelWidth="auto" 
	>
	
	<mat-option
		*ngFor="let item of filteredItems$ | async"
		[value]="item"
		>

		{{ getLabel(item) }}
	</mat-option>
</mat-autocomplete>
